import React, { FC, memo } from 'react'

import { NativeModal, useNativeModalActions } from '@Components/Modal/NativeModal/NativeModal'
import { CartV2LineItems, CartV2Totals, CartV2Type } from '@Domains/Cart/Feature/CartV2/CartV2'
import { OrderSummaryTriggerV2 } from '@Domains/Checkout/OrderSummary/OrderSummaryTrigger'
import { OrderSummaryV3 } from '@Domains/Checkout/OrderSummary/OrderSummaryV3'
import { Money } from '@Globals/Money'

import styles from './CheckoutFlowOrderSummary.module.scss'

export interface CheckoutFlowOrderSummaryProps {
  expectedDelivery?: string
  lineItemGroups?: CartV2Type['lineItemGroups']
  lineItems: CartV2LineItems
  totals: CartV2Totals
}
export const CheckoutFlowOrderSummary: FC<CheckoutFlowOrderSummaryProps> = memo(({
  expectedDelivery,
  lineItemGroups,
  lineItems,
  totals,
}) => {
  const actionRef = useNativeModalActions()

  const grandTotal = totals.find(total => total.id === 'grand_total')

  if (!grandTotal) {
    return null
  }
  return (
    <div className={styles.checkoutFlowOrderSummary}>
      <OrderSummaryTriggerV2
        grandTotal={grandTotal?.value as Money || 0}
        onClick={() => {
          actionRef.current?.open()
        }}
      />
      <NativeModal
        actionRef={actionRef}
        alignment="right"
        backdrop
        className={styles.checkoutFlowOrderSummaryModal}
        closeOnBackDrop
        closeOnEscape
        onClose={() => actionRef.current?.close()}

      >
        <OrderSummaryV3
          expectedDelivery={expectedDelivery}
          lineItemGroups={lineItemGroups}
          lineItems={lineItems}
          onClose={actionRef.current?.close}
          totals={totals}
        />
      </NativeModal>
    </div>
  )
})
